import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DateTime } from 'luxon';
import { AutoTranslateDirective } from 'app/shared/directives/auto-translate.directive';
import { AutoTranslatePipe } from 'app/shared/pipes/translate.pipe';

export interface CloseAllocationDialogData {
    timezone: string;
    label: string;
    crewCount?: number;
    isOnlyDriver?: boolean;
}

export type CloseAllocationDialogResult =
    | { mode: 'cancel' }
    | { mode: 'confirm'; ended_at: string; scope: 'person' | 'all' };

@Component({
    selector: 'app-close-allocation-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        AutoTranslateDirective,
        AutoTranslatePipe,
    ],
    templateUrl: './close-allocation-dialog.component.html',
    styleUrls: ['./close-allocation-dialog.component.scss'],
})
export class CloseAllocationDialogComponent {
    endedAtLocal: string;
    scope: 'person' | 'all';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CloseAllocationDialogData,
        private dialogRef: MatDialogRef<CloseAllocationDialogComponent, CloseAllocationDialogResult>,
    ) {
        this.endedAtLocal = DateTime.now().setZone(data.timezone).toFormat("yyyy-MM-dd'T'HH:mm");
        this.scope = this.hasCrewChoice && !data.isOnlyDriver ? 'person' : 'all';
    }

    get hasCrewChoice(): boolean {
        return (this.data.crewCount ?? 1) > 1;
    }

    cancel(): void {
        this.dialogRef.close({ mode: 'cancel' });
    }

    selectScope(scope: 'person' | 'all'): void {
        if (scope === 'person' && this.data.isOnlyDriver) return;
        this.scope = scope;
    }

    confirm(): void {
        if (!this.endedAtLocal) return;
        const dt = DateTime.fromISO(this.endedAtLocal, { zone: this.data.timezone });
        this.dialogRef.close({
            mode: 'confirm',
            ended_at: dt.toUTC().toISO()!,
            scope: this.hasCrewChoice ? this.scope : 'all',
        });
    }
}
